import breakpoints from './breakpoints';

export default {
  'break-1': window.matchMedia(`(min-width: ${breakpoints['break-1']}px)`),
  'break-2': window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`),
  'break-3': window.matchMedia(`(min-width: ${breakpoints['break-3']}px)`),
  'break-4': window.matchMedia(`(min-width: ${breakpoints['break-4']}px)`),
  'break-5': window.matchMedia(`(min-width: ${breakpoints['break-5']}px)`),
};
